import { E_WebDisplayCellType } from "../../../../../enums/smart-display/cell-type.enum";
import { E_WebDisplaySection } from "../../../../../enums/smart-display/section.enum";
import { I_CellConfig } from "../../home/api/card-config.response";

export interface I_SectionBoxLayoutResponse {
  id: string
  type: E_WebDisplaySection;
  name: string;
  icon: string;
  sectionUrl: string;
  subtitle: boolean;
  isColumn: boolean;
  conditions: I_ConditionsConfigResponse;
  paddingTop?: string;
  paddingBottom?: string;
  paddingLeft?: string;
  paddingRight?: string;
  borderColor?: string;
  borderWidth?: string;
  borderStyle?: string;
  borderRadius?: string;
  hProportion?: number;
  minHeight?: string;
  bgColor?: string;
  cells: I_RowBoxLayoutResponse[];
  direction: E_FlexDirectionResponse;
  growPriority: number;
}
export interface I_DetailTabConfigResponse {
  id: string;
  label: string;      // "Pase médico", "Pase guardia", etc.
  icon?: string;
  rows: I_SectionBoxLayoutResponse[];    // El array de secciones estructuradas (rows, observations) que ya lee tu motor
}
export enum E_FlexDirectionResponse {
  Column = "Column",
  Row = "Row",
  RowReverse = "RowReverse",
  ColumnReverse = "ColumnReverse",
}

export interface I_ConditionsConfigResponse {
  condition: string;
  fieldCondition: string;
}
export interface I_RowBoxLayoutResponse {
  growPriority: number;
  type?: E_WebDisplayCellType;
  bgColor?: string;
  cells: I_CellConfig[];
  paddingTop?: string;
  paddingBottom?: string;
  paddingLeft?: string;
  paddingRight?: string;
  direction: E_FlexDirectionResponse;
  minWidth?: string;
  minHeight?: string;
  valuePathNested?: string;
  valuePathKey?: string[];
}
